import { useState } from "react";
import { PlayCircle, Film } from "lucide-react";
import { StudioAnimation } from "@/components/SvgSandbox";

// Componente único de demonstração: carrega o vídeo apenas quando o utilizador pede.
export default function DemoMedia({ demo }) {
  const [play, setPlay] = useState(false);
  if (!demo) {
    return (
      <div className="aspect-video rounded-xl border border-dashed border-slate-700 bg-slate-900/40 flex flex-col items-center justify-center gap-2 text-slate-500 text-sm" data-testid="demo-pending">
        <Film className="w-6 h-6" strokeWidth={1.5} />
        Demonstração pendente
        <span className="text-[11px] text-slate-500">Sem conteúdo aprovado para este item.</span>
      </div>
    );
  }
  if (demo.kind === "studio" && demo.svg) return <StudioAnimation svg={demo.svg} />;
  if (demo.kind === "image") {
    return <img src={demo.url} alt="Demonstração" loading="lazy" className="w-full rounded-xl border border-slate-800 object-contain bg-slate-950" data-testid="demo-image" />;
  }
  if (!play) {
    return (
      <button type="button" onClick={() => setPlay(true)} data-testid="demo-play-btn"
        className="aspect-video w-full rounded-xl border border-sky-500/30 bg-slate-900/60 flex flex-col items-center justify-center gap-2 text-sky-300 hover:bg-sky-500/10 transition-colors">
        <PlayCircle className="w-10 h-10" strokeWidth={1.25} />
        <span className="text-xs">Ver demonstração</span>
      </button>
    );
  }
  return demo.kind === "embed" ? (
    <iframe src={demo.url} title="Demonstração" loading="lazy" allow="encrypted-media; picture-in-picture; fullscreen" allowFullScreen
      className="aspect-video w-full rounded-xl border border-slate-800" data-testid="demo-embed" />
  ) : (
    <video src={demo.url} controls autoPlay playsInline preload="none" className="aspect-video w-full rounded-xl border border-slate-800 bg-black" data-testid="demo-video" />
  );
}
